import { getMessage } from "../../../../services/graphql/queries/messageConfiguration";
import {withApollo} from "react-apollo"
import React from "react"
import { SET_TIMEOUT_VALUE } from "../../../../constants/app-constants";
import { withRouter } from "react-router-dom";
import { updateMessageConfiguration } from "../../../../services/graphql/queries/messageConfiguration";
import DisplayErrors from "../../../Common/DisplayErrors";
import NumberFormat from "react-number-format";
class EmailView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      subject: "",
      subjectMsg: "",
      priority: "",
      priorityMsg: "",
      msgTemplate: "",
      messageDataMsg: "",
      message: {},
      Id: "",
      errors: [],
      formStyle: "",
      formisValid: true
    };
    this.getData = this.getData.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.handleValidation = this.handleValidation.bind(this);
  }

  getData() {
    console.log("AppView", this.props.message);
    this.props.client
      .query({
        query: getMessage,
        variables: {
          messageId: parseInt(this.state.Id),
          deliveryMode: "EMAIL"
        },

        fetchPolicy: "network-only"
      })
      .then(result => {
        const message = result.data.getMessage;
        console.log("result~~~~", message);

        this.setState({ ...message });
      })
      .catch(error => {
        error.graphQLErrors.map(({ message }, i) => {
          this.setState(prevState => {
            return { errors: [message] };
          });
        });
        setTimeout(() => {
          this.setState({ errors: [] });
        }, SET_TIMEOUT_VALUE);
      });
  }
  // componentWillReceiveProps(nextProps) {
  //   console.log("props", nextProps);
  //   if (nextProps.message && nextProps.message.Id) {
  //     this.state.Id = nextProps.message.Id;
  //     // this.getData();
  //     this.setState({ ...this.props.emailData });
  //   }
  // }
  componentDidMount() {
    if (this.props.message && this.props.message.Id) {
      this.state.Id = this.props.message.Id;
      // this.getData();
      this.setState({ ...this.props.emailData });
    }
  }
  handleValidation() {
    console.log("handle validation");
    var isValid = true;
    var style = "is-invalid";
    if (this.state.priority == "") {
      this.setState({
        priorityMsg: "Please enter  valid data",
        formStyle: style
      });
      isValid = false;
    } else {
      this.setState({
        priorityMsg: ""
      });
    }
    if (this.state.msgTemplate == "") {
      console.log("inside validation");
      this.setState({
        messageDataMsg: "Please enter valid data",
        formStyle: style
      });
      isValid = false;
    } else {
      this.setState({
        messageDataMsg: ""
      });
    }
    if (this.state.subject == "") {
      console.log("inside validation");
      this.setState({
        subjectMsg: "Please enter valid data",
        formStyle: style
      });
      isValid = false;
    } else {
      this.setState({
        subjectMsg: ""
      });
    }

    return isValid;
  }
  submitForm(e) {
    e.preventDefault();
    if (this.handleValidation()) {
      this.props.client
        .mutate({
          mutation: updateMessageConfiguration,
          variables: {
            id: this.state.Id,
            priority: parseInt(this.state.priority),
            msgTemplate: this.state.msgTemplate,
            subject: this.state.subject
          }
        })
        .then(result => {
          console.log("result~~~", result);

          this.props.success(true);
          this.props.toggleMode(false);
        })
        .catch(error => {
          console.log("~~~error: ", error);
          error.graphQLErrors.map(({ message }, i) => {
            this.setState(prevState => {
              return { errors: [message] };
            });
          });
          setTimeout(() => {
            this.setState({ errors: [] });
          }, SET_TIMEOUT_VALUE);
        });
    }
  }
  reset = () => {
    this.setState({
      ...this.props.emailData,
      messageDataMsg: "",
      subjectMsg: "",
      priorityMsg: ""
    });
  };
  render() {
    const { message, priority, errors, subject, msgTemplate } = this.state;

    console.log("email,", priority);
    return (
      <>
        <div
          className="tab-pane fade show active"
          id="msg"
          role="tabpanel"
          aria-labelledby="msg-tab"
        >
          <div className="box-card">
            <div className="row align-items-center">
              <div className="col">
                <h1 className="heading m-b-0">Mail Details</h1>
              </div>
            </div>
            <div
              className="row"
              style={{
                display: errors.length === 0 ? "none" : "block"
              }}
            >
              <div className="col-md-6">
                {/* Alert Section start */}
                <div className="alert alert-success" role="alert">
                  <div className="row">
                    <img src="/static/images/svg/Serverclose.svg" />
                    &nbsp;
                    <span className="danger-link">
                      <DisplayErrors errors={errors} />
                    </span>
                  </div>
                </div>
                {/*Alert Section End */}
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-md-12 col-lg-12">
                <div className="row">
                  <div className="col-md-12 col-lg-4">
                    <div className="form-group">
                      <label>
                        Subject<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Enter Subject"
                        onChange={e => {
                          this.setState({ subject: e.target.value });
                        }}
                        className={
                          "form-control " +
                          (this.state.subjectMsg != ""
                            ? this.state.formStyle
                            : "")
                        }
                        value={subject}
                      />
                      <div className="invalid-feedback">
                        {this.state.subjectMsg}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 col-lg-3">
                    <div className="form-group">
                      <label>
                        Priority<span style={{ color: "red" }}>*</span>
                      </label>
                      {/* <input
                        type="text"
                        onChange={e => {
                          this.setState({ priority: e.target.value });
                        }}
                        className={
                          "form-control " +
                          (this.state.priorityMsg != ""
                            ? this.state.formStyle
                            : "")
                        }
                        value={this.state.priority}
                      /> */}
                      <NumberFormat
                        format="#"
                        placeholder="Enter Priority"
                        value={priority}
                        className={
                          "form-control " +
                          (this.state.priorityMsg != ""
                            ? this.state.formStyle
                            : "")
                        }
                        onValueChange={values => {
                          this.setState({ priority: values.value });
                        }}
                      />
                      <div className="invalid-feedback">
                        {this.state.priorityMsg}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 col-lg-12">
                    <div className="form-group">
                      <label>
                        Message<span style={{ color: "red" }}>*</span>
                      </label>
                      <textarea
                        type="text"
                        placeholder="Enter Message"
                        className={
                          "text-medium form-control " +
                          (this.state.messageDataMsg != ""
                            ? this.state.formStyle
                            : "")
                        }
                        onChange={e => {
                          this.setState({ msgTemplate: e.target.value });
                        }}
                        id="textarea"
                        value={msgTemplate}
                      />
                      <div className="invalid-feedback">
                        {this.state.messageDataMsg}
                      </div>
                    </div>
                    <br />
                    {/* <button
                      type="button"
                      className="btn btn-danger"
                      onClick={this.submitForm}
                    >
                      Submit
                    </button> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-5">
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={this.submitForm}
                >
                  Submit
                </button>
                {/* </div>
              <div className="col-md-1"> */}
                <button
                  type="button"
                  className="btn btn-light m-l-50"
                  onClick={this.reset}
                >
                  Reset
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withApollo(EmailView);
